import { getIsOutsideTrimmingRange, getStartTimeForDisplay } from 'bundles/video-trim';

class Cue {
  declare id: string;

  declare index: number;

  declare startTime: number;

  declare endTime: number;

  declare text: string;

  declare startTimeForDisplay: number;

  declare hideForTrimmingRange: boolean;

  constructor(
    id: $TSFixMe,
    index: $TSFixMe,
    text: $TSFixMe,
    startTime: $TSFixMe,
    endTime: $TSFixMe,
    trimmedStartTimeSeconds = 0,
    trimmedEndTimeSeconds?: number | null | undefined
  ) {
    this.id = id;
    this.index = index;
    this.startTime = startTime; // double, in seconds. The actual start time of the cue, relative to the entire video.
    this.endTime = endTime; // double, in seconds. The actual end time of the cue, relative to the entire video.

    this.text = text
      .replace('<br/>', ' ')
      .replace('\n', ' ')
      .replace(/^\.$/, '')
      .replace(/&#(\d+);/g, (match: $TSFixMe, character: $TSFixMe) => String.fromCharCode(character));

    // The start time of the cue, relative to the video's trimmed range (if there is one).
    this.startTimeForDisplay = getStartTimeForDisplay(this.startTime, trimmedStartTimeSeconds);

    this.hideForTrimmingRange = getIsOutsideTrimmingRange(this.startTime, this.endTime, {
      trimmedStartTimeSeconds,
      trimmedEndTimeSeconds,
    });
  }
}

export default Cue;
